import { atom } from "recoil";
import {
  setPublishedTaskEditorTasksCache,
  setTaskEditorWorkingDraftCache,
  type PublishedTaskEditorTask,
} from "pages/task-editor/utils/taskEditorRuntime";
import type { TaskEditorState } from "pages/task-editor/utils/taskEditorUtils";

export const taskEditorPublishedTasksAtom = atom<PublishedTaskEditorTask[]>({
  key: "taskEditorPublishedTasksAtom",
  default: [],
  effects_UNSTABLE: [
    ({ onSet }) => {
      setPublishedTaskEditorTasksCache([]);
      onSet((nextTasks: PublishedTaskEditorTask[]) => {
        setPublishedTaskEditorTasksCache(nextTasks);
      });
    },
  ],
});

export const taskEditorWorkingDraftAtom = atom<TaskEditorState | undefined>({
  key: "taskEditorWorkingDraftAtom",
  default: undefined,
  effects_UNSTABLE: [
    ({ onSet }) => {
      setTaskEditorWorkingDraftCache(undefined);
      onSet((nextDraft: TaskEditorState | undefined) => {
        setTaskEditorWorkingDraftCache(nextDraft);
      });
    },
  ],
});

export const taskEditorDraftsByTaskIdAtom = atom<
  Record<string, TaskEditorState>
>({
  key: "taskEditorDraftsByTaskIdAtom",
  default: {},
});

export const taskEditorStoreHydratedAtom = atom<boolean>({
  key: "taskEditorStoreHydratedAtom",
  default: false,
});

export const taskEditorStoreLoadingAtom = atom<boolean>({
  key: "taskEditorStoreLoadingAtom",
  default: false,
});
